<template lang="pug">
.uk-position-top(v-if="message")
  div(:class="message.type == 'error' ? 'uk-alert-danger' : 'uk-alert-success'", uk-alert)
    a.uk-alert-close(uk-close)
    div {{ message.text }}

</template>

<script>
// import * as types from '../js/mutations/map-mutations'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['message'])
  },
}

</script>
